import React, { ReactElement, useEffect } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { reCaptcha } from 'utils/helpers/reCaptcha';
import RootLayout from 'layouts/RootLayout';
import Breadcrumbs from 'components/Breadcrumbs';
import { Contact } from 'sections/Company/ContactUs/components/Contact';
import { Settings } from 'sections/Company/ContactUs/types';
import styles from 'pages/company/contact-us/ContactUs.module.scss';

const cn = classNames.bind(styles);

export default function ContactUs() {
  const [{ user }] = useCookies(['user']);
  const { logged } = useSelector((state: RootState) => state.userData);

  let contact: Settings = {
    subject: ['IT Service', 'Logistics Service', 'Digital Freight Alliance', 'Other'],
    platform: 'df-alliance',
    addressVisible: true,
  };

  if (logged) {
    contact = {
      ...contact,
      ...{
        name: user?.name,
        email: user?.email,
        phone: user?.phone
      }
    }
  }

  useEffect(() => {
    reCaptcha();
  }, []);

  return (
    <div className={cn('contact-us')}>
      <div className={cn('container')}>
        <Breadcrumbs mTop={64} mode="dark" links={[{ title: 'Contact Us', href: '' as Route }]} />

        <div className={cn('contact-us__container')}>
          <Contact contact={contact} />
        </div>

      </div>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Get in Touch with DF Alliance | DF Alliance',
      description: 'Contact DF Alliance to get in touch with their expert team for inquiries, support, and assistance with global logistics solutions and freight forwarding needs.',
      path: '/company/contact-us',
    },
  };
};

ContactUs.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
